export const SET_USER_INFO = 'SET_USER_INFO';
export const SET_USER_LOGGED_IN = 'SET_USER_LOGGED_IN';